// delLists/draftLists/state.js

export const draftsInitialState = {
  items: [],
  tableType: "drafts",
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  error: null,
  needsUpdate: false,
  selectedDraft: null,
};
